import Swiper, { Pagination, Navigation, Autoplay } from "swiper";
import { $Q, $Qll } from "../utils/query-selector";

import 'swiper/css/bundle';

const setupHeroSlider = () => {
  const sliderHero = $Q(".hero");
  const sliderItems = $Qll(".hero-item");

  if (sliderItems.length <= 1) return;

  if (!sliderHero) return;

  Swiper.use([Pagination, Navigation, Autoplay]);

  let autoplayObject = false;

  const { time, autoplay } = sliderHero.dataset;

  // eslint-disable-next-line radix
  const milliseconds = parseInt(time) * 1000

  if (autoplay === "true") {
    autoplayObject = {
      delay: milliseconds,
    }
  }

  const swiperSettings = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    pagination: {
      el: '.hero__pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.hero__arrow--next',
      prevEl: '.hero__arrow--prev',
    },
    autoplay: autoplayObject,
  };

  // eslint-disable-next-line no-new
  new Swiper(sliderHero, swiperSettings);
};

export default setupHeroSlider;
